import { inject, Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve } from '@angular/router';
import { Apollo } from 'apollo-angular';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { GetProductDetailQuery } from '../../common/generated-types';
import { GET_PRODUCT_DETAIL } from '../../common/graphql/documents.graphql';


@Injectable({
  providedIn: 'root',
})
export class ProductResolver implements Resolve<GetProductDetailQuery['product']> {
  private apollo = inject(Apollo);

  resolve(route: ActivatedRouteSnapshot): Observable<any> {
    const slug = route.paramMap.get('slug');

    return this.apollo
      .query({
        query: GET_PRODUCT_DETAIL,
        variables: { slug },
        fetchPolicy: 'network-only'
      })
      .pipe(
        map((result: any) => result.data.product)
      );
  }
}